import * as React from "react";
import { SectionContainer } from "../layout";
import * as navigation_fr from "./fr-FR/footer";
import * as navigation_be from "./fr-BE/footer";
import * as navigation_de from "./de-DE/footer";
import {
  LANG_DE_DE,
  LANG_EN_US,
  LANG_FR_BE,
  LANG_FR_FR,
} from "../../constants";
import { t } from "../../translations";

const LOCALE_TO_FOOTER_NAVIGATION = {
  [LANG_FR_FR]: navigation_fr.Footer,
  [LANG_FR_BE]: navigation_be.Footer,
  [LANG_DE_DE]: navigation_de.Footer,
};

// All the langs where we remove the padding top of the footer. @todo update once we have correct navigation
const NO_PADDING_TOP_LOCALES = [LANG_EN_US];

/**
 * The bottom Foooter, locale dependant. Defaults to french
 * Contains the bottom navigation and the copyrights
 */
export const Footer = ({ locale = LANG_FR_FR }) => (
  <SectionContainer
    fullWidth
    removePaddingTop={NO_PADDING_TOP_LOCALES.includes(locale)}
  >
    <footer className="bg-white" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      {LOCALE_TO_FOOTER_NAVIGATION[locale] && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12 ">
          {LOCALE_TO_FOOTER_NAVIGATION[locale]}
        </div>
      )}
      <div className="border-t border-gray-200 pt-8">
        <p className="text-base text-gray-400 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          &copy; {new Date().getFullYear()} {t(locale, "footer.all-rights")}
        </p>
      </div>
    </footer>
  </SectionContainer>
);
